export const BACKEND_ERRORS = {
  NOT_AUTH_TO_DO: "You're not authorized to do this.",
  NO_SPENDABLE_BUNDLE_ITEMS: 'No spendable bundle items for category',
};
